<script lang="ts">
  import { Input } from '$lib/components/ui/input/index.js';

  interface Props {
    onUpdate?: any;
    value: number | undefined;
    enabled?: boolean;
  }

  let { value, onUpdate, enabled = true }: Props = $props();
</script>

<Input type="number" {value} step="0.1" disabled={!enabled} class="w-1/2" oninput={onUpdate} />
